<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">

            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
            </div>
        </div>
        <div class="scrollbar-container" style="background: var(--contrast-0);" :class="anonMode ? 'anonblur' : ''">
            <div v-if="mainType">
                <div class="vlh-lane">
                    <div v-for="lane in lanes" :key="lane.name">
                        <div class="vlh-lane-section vlh-light-gray">
                            <div class="vlh-section-label" :style="{ 'background-color': lane.color }">
                                {{ lane.name }}
                                <button class="vlh-light-btn" :style="{ 'background-color': lane.color }"
                                        @click="OpenCreatePlanningEmployeeThresholdModal($event, getSpotsForUnit(lane.unitId))">
                                    <i class="fas fa-plus-circle"></i>
                                </button>
                            </div>
                            <div v-for="state in lane" :key="state.cardId">
                                <div>
                                    <meocard :state="state" :laneColor="lane.color"
                                             :OpenCreatePlanningEmployeeThresholdModal="OpenCreatePlanningEmployeeThresholdModal"
                                             :OpenEditPlanningEmployeeThresholdModal="OpenEditPlanningEmployeeThresholdModal"
                                             :OpenDeletePlanningEmployeeThresholdModal="OpenDeletePlanningEmployeeThresholdModal"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h3 v-else style="color: red;">{{ $t('roster.error.defaultKeyFigureMissing') }}</h3>
        </div>


        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
    </div>

</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import Papa from 'papaparse';
import { mapState, mapGetters } from 'vuex';
import Meocard from "@/components/uicomponents/meocard.vue";

export default {
    name: 'planningemployeethresholdoverview',
    components: {
        Meocard,
    },
    data() {
        return {

            mainTypeId: null,
            error: false,
            loading: true,
            loadingText: null,
        }
    },

    created: function () {
        if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
            this.refresh();
        }
    },
    computed: {
        ...mapGetters([ 'storeId', 'anonMode', 'planningIndicatorTypeMap', 'planningEmployeeThresholdMap', 'spotMap', 'storeSettings', 'isSuperUser', 'rosterFromTo', 'businessUnitMap' ]),
        headerButtons() {

            let view = this;

            let state = {
                buttons: []
            };
            //BUTTON 1
            state.buttons.push({
                type: "block",
                icon: "fa-sync-alt",
                click: () => {
                    view.refresh(true);
                },
                tooltip: this.$t('global.general.refreshData')
            });
            state.buttons.push({
                type: "block green",
                icon: "fa-plus",
                click: ($event) => {
                    view.OpenCreateMultiplePlanningEmployeeThresholdModal($event);
                },
                tooltip: this.$t('indicator.meo.addMultiple'),
                helperText: this.$t('indicator.meo.addMultipleHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2049441793"
            });
            state.buttons.push({
                type: "block orange",
                icon: "fa-plus",
                click: ($event) => {
                    view.OpenReversePlanningEmployeeThresholdModal($event);
                },
                tooltip: this.$t('indicator.meo.createFromRoster'),
                helperText: this.$t('indicator.meo.createFromRosterHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2049441793"
            });

            state.buttons.push({
                type: "block red",
                icon: "fa-times",
                click: ($event) => {
                    view.openDeleteConfirmAlert();
                },
                tooltip: this.$t('indicator.meo.deleteValues'),
                helperText: this.$t('indicator.meo.deleteValuesHelp'),
            });
            state.buttons.push({
                type: "block border-r",
                icon: "fa-file-csv",
                click: () => {
                    view.openCSVImportPopup();
                },
                tooltip: this.$t('indicator.meo.importCsv'),
                helperText: this.$t('indicator.meo.importCsvHelp'),
                externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/article/2049441793"

            })
            state.buttons.push({
                type: "block border-r",
                icon: "fa-file-download",
                click: () => {
                    view.exportCSV();
                },
                tooltip: this.$t('indicator.meo.exportCsv'),
                helperText: this.$t('indicator.meo.exportCsvHelp'),


            })
            state.helperLinks = [
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close')
                }
            ];
            return state;
        },
        spotItems() {
            return Object.values(this.spotMap).sort((a, b) => {
                let spotA = a.name.toLowerCase();
                let spotB = b.name.toLowerCase();
                if (spotA < spotB) {
                    return -1;
                } else if (spotA > spotB) {
                    return 1;
                } else {
                    return 0;
                }
            }).map(i => {
                return { label: i.name, value: i.id }
            });
        },
        mainType() {
            let def = Object.values(this.planningIndicatorTypeMap).filter(i => i.isDefault == true);
            if (def.length > 0) {
                return def[0]
            } else {
                return null;
            }
        },
        spotEmployeeThresholdMaps() {
            let map = {};
            const mainTypeId = this.mainType ? this.mainType.id : null;
            Object.values(this.spotMap).forEach(spot => {
                map[spot.id] = {}
            });
            Object.values(this.planningEmployeeThresholdMap).forEach(item => {
                if (map[item.spotId] && item.typeId == mainTypeId) {
                    map[item.spotId][item.id] = item;
                }
            })
            return map;
        },
        thresholdSpotEmployeeMap() {
            let map = {};
            const mainTypeId = this.mainType ? this.mainType.id : null;
            Object.values(this.planningEmployeeThresholdMap).sort((a, b) => {
                return a.threshold - b.threshold;
            }).forEach(item => {
                if (item.typeId == mainTypeId) {
                    let key = item.threshold / Math.pow(10, this.planningIndicatorTypeMap[mainTypeId].fractional) + "";
                    key = key.replace(".", ",");
                    if (map[key] == null) {
                        map[key] = {};
                    }
                    map[key][item.spotId] = item.employeeCount;

                }
            });
            return map;
        },
        lanes() {
            let view = this;

            let unitColorMap = [];
            Object.values(this.spotMap).filter(spot => spot.isMain).forEach(spot => {
                unitColorMap[spot.unitId] = spot.color;
            });

            let lanes = new Map;
            Object.values(this.businessUnitMap).forEach(businessUnit => {
                let lane = [];
                lane.name = businessUnit.name;
                lane.color = unitColorMap[businessUnit.id];
                lane.time = this.selectedTime;
                lane.unitId = businessUnit.id;
                lane.priority = businessUnit.priority;
                lanes.set(businessUnit.id, lane);
            });

            const mainTypeId = this.mainType ? this.mainType.id : null;

            Object.values(this.spotMap).sort((a, b) => {
                return a.name.localeCompare(b.name);
            }).forEach(spot => {
                let values = Object.values(this.planningEmployeeThresholdMap)
                    .filter(i => i.typeId === mainTypeId && i.spotId === spot.id).sort((a, b) => {
                        return a.threshold - b.threshold;
                    });
                if (values.length > 0) {
                    let state;

                    state = this.$helpers.GetDataTableStateFromObject({
                        typeId: '',
                        timeId: '',
                        spotId: '',
                        unitName: '',
                        threshold: 0,
                        employeeCount: 0
                    }, values);
                    state.headerMap['typeId'].sort = false;
                    state.headerMap['typeId'].label = this.$t('roster.view.keyFigure');
                    state.headerMap['typeId'].DisplayLabel = (i) => {
                        return this.planningIndicatorTypeMap[i.typeId].name
                    };

                    state.headerMap['spotId'].sort = false;
                    state.headerMap['spotId'].label = this.$tc('shift.main.position');
                    state.headerMap['spotId'].DisplayLabel = (i) => {
                        return this.spotMap[i.spotId].name
                    };

                    state.headerMap['threshold'].sort = false;
                    state.headerMap['threshold'].label = this.$t('indicator.meo.hourThreshold');
                    state.headerMap['threshold'].DisplayLabel = (i) => {
                        return (( i.threshold / Math.pow(10, this.mainType.fractional) )*4).toFixed(2)
                    };


                    state.headerMap['employeeCount'].sort = false;
                    state.headerMap['employeeCount'].label = this.$t('global.general.employeeCount');

                    state.headerMap['actions'] = {
                        align: 'center',
                        button: {
                            icon: 'fas fa-plus',
                            action: ($event, data) => view.OpenCreatePlanningEmployeeThresholdModal($event)
                        },
                        buttons: [
                            {
                                icon: 'fas fa-edit',
                                action: ($event, data) => view.OpenEditPlanningEmployeeThresholdModal($event, data)
                            },
                            {
                                icon: 'fas fa-trash',
                                action: ($event, data) => view.OpenDeletePlanningEmployeeThresholdModal($event, data)
                            },
                        ]
                    };

                    state.headerMap['actions'].width = '100px';
                    state.spot = spot.name;
                    state.spotId = spot.id;
                    state.cardId = spot.name
                    state.color = spot.color;
                    state.priority = spot.priority;

                    if (!lanes.get(spot.unitId)) {
                        lanes.set(spot.unitId, []);
                    }
                    lanes.get(spot.unitId).push(state);
                }


            })

            return [ ...lanes.values() ].filter(value => value.length > 0)
                .sort((a, b) => {
                    let val = Number(a.priority) - Number(b.priority);
                    return val !== 0 ? val : a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                }).map(lane => lane.sort((a, b) => {
                    let val = Number(a.priority) - Number(b.priority);
                    return val !== 0 ? val : a.spot.toUpperCase().localeCompare(b.spot.toUpperCase());
                }))
        },
    },
    watch: {
        storeId: function (val, oldVal) {
            this.refresh(true);
        },
    },
    // methods that implement data logic.
    methods: {
        refresh: function (force = false) {
            let view = this;
            this.loading = true;
            this.$helpers.GetSpotMap(force)
                .then(map => {
                    return view.$helpers.GetPlanningIndicatorTypeMap(force);
                }).then(map => {
                return view.$helpers.GetPlanningEmployeeThresholdMap(force);
            }).then(map => {
                return view.$helpers.GetBusinessUnitMap(force);
            }).then(map => {
                view.loading = false;
            })
                .catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                    view.loading = false;
                    console.log(error)
                });
        },
        getSpotsForUnit(unitId) {
            return Object.values(this.spotMap).filter(spot => spot.unitId === unitId);
        },
        OpenCreatePlanningEmployeeThresholdModal($event, spotId = null) {
            let selectedSpotItem = spotId == null ? null : this.spotItems.find(i => i.value === spotId);

            let spotIdIsArray = Object.prototype.toString.call(spotId) === '[object Array]';
            let spotDrownDownItems = this.spotItems;
            if (spotIdIsArray) {
                spotDrownDownItems = spotId.map(spot => ( {
                    value: spot.id, label: spot.name
                } ))
                console.log(spotId);
                console.log(spotDrownDownItems)
            }

            let view = this;
            let unit = ( this.mainType.unit != null && this.mainType.unit != '' ) ? '(' + this.mainType.unit + ')' : '';
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: true, type: 'text', value: this.mainType.id },
                        {
                            label: this.$tc('shift.main.position'),
                            key: 'spotId',
                            hidden: false,
                            disabled: spotId != null && !spotIdIsArray,
                            type: 'dropdownsearch',
                            value: null,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: spotDrownDownItems,
                                selectMultiple: false,
                                selectedItems: selectedSpotItem == null ? [] : [ selectedSpotItem ],
                                selectedItem: selectedSpotItem,
                                selectFirst: spotId == null ? true : false,
                                styleLight: true,
                            }
                        },
                        { label: this.$t('indicator.meo.hourThreshold') + ' ' + unit, key: 'threshold', hidden: false, type: 'numeric', value: 0 },

                        {
                            label: this.$t('global.general.employeeCount'),
                            key: 'employeeCount',
                            hidden: false,
                            type: 'numeric',
                            value: 0,
                            min: 0
                        },
                    ],
                    selectCallback: function (data) {
                        view.createPlanningEmployeeThreshold(data);
                    }
                },
                header: this.$t('indicator.meo.newValue') + ' ' + this.mainType.name,
                centered: true,
                expanded: true,
            });
        },
        createPlanningEmployeeThreshold: function (item) {
            let view = this;
            let url = '/api/sec/planningemployeethreshold';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                typeId: item.typeId,
                spotId: item.spotId,
                threshold: Math.round((item.threshold/4.0) * Math.pow(10, this.mainType.fractional)),
                employeeCount: item.employeeCount
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setPlanningEmployeeThresholdMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.meo.valueAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.addValueError'));
                console.log(error)
            })

        },
        OpenCreateMultiplePlanningEmployeeThresholdModal($event) {
            let view = this;
            let entries = [];

            let unit = ( this.mainType.unit != null && this.mainType.unit != '' ) ? '(' + this.mainType.unit + ')' : '';
            entries.push({ label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: true, type: 'text', value: this.mainType.id });
            entries.push({ label: this.$t('indicator.meo.hourThreshold') + ' ' + unit, key: 'threshold', hidden: false, type: 'numeric', value: 0 });
            entries.push({ divider: true });
            Object.values(this.spotMap).sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            }).forEach(spot => {
                let key = spot.id;
                let label = spot.name + " " + this.$t('indicator.meo.empShort');
                entries.push({ label: label, key: key, hidden: false, type: 'numeric', value: 0, min: 0 })

            })

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: entries,
                    selectCallback: function (item) {
                        let requests = [];
                        Object.values(view.spotMap).forEach(spot => {
                            let key = spot.id;
                            if (item[key] > 0) {
                                requests.push({
                                    typeId: item.typeId,
                                    threshold: item.threshold,
                                    spotId: spot.id,
                                    employeeCount: item[key]
                                });
                            }

                        });
                        if (requests.length > 0) {
                            view.createMultiplePlanningEmployeeThreshold(requests);
                        }

                    }
                },
                header: this.$t('indicator.meo.newValues') + ' ' + this.mainType.name,
                centered: true,
                expanded: true,
            });
        },
        createMultiplePlanningEmployeeThreshold: function (items) {
            let view = this;
            let url = '/api/sec/planningemployeethreshold/multiple';
            let params = {
                storeId: this.storeId,
            }

            let payload = {
                requests: []
            }
            items.forEach(item => {
                let o = {
                    storeId: this.storeId,
                    typeId: item.typeId,
                    spotId: item.spotId,
                    threshold: Math.round((item.threshold/4.0) * Math.pow(10, this.mainType.fractional)),
                    employeeCount: item.employeeCount
                };
                payload.requests.push(o);
            })


            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.refresh(true);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.meo.newValuesAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.addValueError'));
                console.log(error)
            })

        },
        OpenReversePlanningEmployeeThresholdModal($event) {
            let view = this;
            let entries = [];

            let modeItems = [ { label: this.$t('store.settings.average'), value: 1 }, { label: "Minimum", value: 2 }, {
                label: this.$t('roster.main.max'),
                value: 2
            } ];
            let plannedItems = [ {
                label: this.mainType.name + this.$t('indicator.vlh.targetBubbleCaps'),
                value: true
            }, { label: this.mainType.name + this.$t('roster.comp.actualBubble'), value: false } ];
            let spotItems = Object.values(this.spotMap).map(spot => {
                return { label: spot.name, value: spot.id, selected: true }
            });

            let from = this.$helpers.getMomentTZ().startOf('month');
            let to = from.clone().add(1, 'months');
            if (this.rosterFromTo != null) {
                from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                to = from.clone().add(1, 'months');
            }


            entries.push({ label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: true, type: 'text', value: this.mainType.id });
            entries.push({
                label: this.$t('global.general.fromDay'),
                key: 'from',
                hidden: false,
                type: 'date',
                value: from,
                flexGroup: true,
                styles: { 'margin-right': '10px' }
            });
            entries.push({ label: this.$t('global.general.toDay'), key: 'to', hidden: false, type: 'date', value: to, flexGroup: true });
            entries.push({
                label: this.$tc('store.structure.spot', 2),
                key: 'spotIds',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: spotItems,
                    selectMultiple: true,
                    selectedItems: spotItems.filter(item => item.selected),
                    styleLight: true,
                }
            });
            entries.push({
                label: this.$t('roster.view.keyFigure'),
                key: 'planned',
                hidden: false,
                type: 'dropdownsearch',
                value: true,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: plannedItems,
                    selectMultiple: false,
                    selectedItems: [],
                    selectFirst: true,
                    styleLight: true,
                }
            });
            entries.push({
                label: this.$t('indicator.meo.mode'), key: 'mode', hidden: false, type: 'dropdownsearch', value: 1, dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: modeItems,
                    selectMultiple: false,
                    selectedItems: [],
                    selectFirst: true,
                    styleLight: true,
                }
            });
            entries.push({
                label: this.$t('indicator.meo.interval'), key: 'bucketSize', hidden: false, value: 10,
                slider: {
                    min: 1,
                    max: 500,
                    hideMin: true,
                    hideMax: true,
                    value: 10,
                    step: 1,
                    inputControl: true,
                    sliderInput: (x) => { return x },
                }
            })
            entries.push({ label: this.$t('indicator.meo.minThreshold') + ' ', key: 'minThreshold', hidden: false, type: 'numeric', value: null });
            entries.push({ label: this.$t('indicator.meo.maxThreshold') + ' ', key: 'maxThreshold', hidden: false, type: 'numeric', value: null });


            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: entries,
                    errorCheck: [
                        (entries) => {

                            if (entries['from'] >= entries['to']) {
                                return {
                                    key: 'from',
                                    type: 'error',
                                    label: this.$t('global.general.fromDay'),
                                    text: this.$t('indicator.meo.startBeforeEnd')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries.to.diff(entries.from, 'days') > 32) {
                                return {
                                    key: 'to',
                                    type: 'error',
                                    label: this.$t('global.general.toDay'),
                                    text: this.$t('indicator.meo.interval31warn')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries['spotIds'] == null || entries['spotIds'].length == 0) {
                                return {
                                    key: 'spotIds',
                                    type: 'error',
                                    label: this.$tc('shift.main.position', 2),
                                    text: this.$t('roster.main.selectBusinessUnitPlease')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries['minThreshold'] != null && isNaN(entries['minThreshold'])) {
                                return {
                                    key: 'minThreshold',
                                    type: 'error',
                                    label: this.$t('indicator.meo.minThreshold'),
                                    text: this.$t('indicator.meo.pleaseEnterNumber')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries['maxThreshold'] != null && isNaN(entries['maxThreshold'])) {
                                return {
                                    key: 'maxThreshold',
                                    type: 'error',
                                    label: this.$t('indicator.meo.maxThreshold'),
                                    text: this.$t('indicator.meo.pleaseEnterNumber')
                                }
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        let payload = {
                            from: item.from,
                            to: item.to,
                            typeId: view.mainType.id,
                            planned: item.planned,
                            bucketSize: item.bucketSize,
                            spotIds: item.spotIds
                        }
                        view.getReverseEmployeeThreshold(payload)
                            .then(response => {
                                let requests = [];
                                let maxBySpotMap = {};

                                response.data.sort((a, b) => {
                                    let val = a.amountFloored - b.amountFloored;
                                    return val;
                                }).forEach(entry => {
                                    let val = Math.round(item.mode == 1 ? entry.avg : ( item.mode == 2 ? entry.min : entry.max ));
                                    if (( item.minThreshold == null || entry.amountFloored >= item.minThreshold ) && ( item.maxThreshold == null || entry.amountFloored <= item.maxThreshold )) {
                                        if (maxBySpotMap[entry.spotId] == null || maxBySpotMap[entry.spotId] < val) {
                                            maxBySpotMap[entry.spotId] = val;
                                            requests.push({
                                                typeId: item.typeId,
                                                threshold: entry.amountFloored,
                                                spotId: entry.spotId,
                                                employeeCount: val
                                            });
                                        }

                                    }

                                });
                                if (requests.length > 0) {
                                    view.createMultiplePlanningEmployeeThreshold(requests);
                                }
                            }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.addValueError'));
                            console.log(error)
                        })


                    }
                },
                header: this.$t('indicator.meo.newValues') + ' ' + this.mainType.name,
                centered: true,
                expanded: true,
            });
        },
        getReverseEmployeeThreshold: function (payload) {
            let view = this;
            let url = '/api/sec/planningemployeethreshold/curve/reverse';
            let params = { storeId: this.storeId }

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            })
        },
        OpenDeletePlanningEmployeeThresholdModal($event, data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('indicator.meo.deleteValue'),
                description: this.$t('indicator.meo.deleteValueQuery'),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deletePlanningEmployeeThreshold(data);
                }
            });
        },
        deletePlanningEmployeeThreshold: function (item) {
            let view = this;
            let url = '/api/sec/planningemployeethreshold';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deletePlanningEmployeeThresholdMapEntry", { id: item.id });
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.meo.valueDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.deleteValueError'));
                console.log(error)
            })

        },
        OpenEditPlanningEmployeeThresholdModal($event, item) {
            let view = this;
            let tvalue = item.threshold*4.0 / Math.pow(10, this.mainType.fractional);
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id },
                        { label: this.$t('indicator.meo.hourThreshold'), key: 'threshold', hidden: false, type: 'numeric', value: tvalue },

                        {
                            label: this.$t('global.general.employeeCount'),
                            key: 'employeeCount',
                            hidden: false,
                            type: 'numeric',
                            value: item.employeeCount,
                            min: 0
                        },
                    ],
                    selectCallback: function (indicatorType) {
                        view.editPlanningEmployeeThreshold(indicatorType);
                    },

                },
                header: this.$t('indicator.meo.editValue'),
                centered: true,
                expanded: true,
            });
        },
        editPlanningEmployeeThreshold: function (item) {
            let view = this;
            let url = '/api/sec/planningemployeethreshold';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                threshold: (item.threshold/4.0) * Math.pow(10, this.mainType.fractional),
                employeeCount: item.employeeCount,
                updateFields: [ "threshold", "employeeCount" ]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.planningEmployeeThresholdMap[item.id]
                data.threshold = payload.threshold;
                data.employeeCount = payload.employeeCount;

                view.$store.commit("setPlanningEmployeeThresholdMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.meo.valueEdited'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.editValueError'));
                console.log(error)
            })

        },
        openDeleteConfirmAlert() {
            let view = this;
            let description = this.$t('indicator.meo.deleteAllQuery');

            view.$helpers.OpenAlert({
                header: this.$t('indicator.meo.confirmDelete'),
                description: description,
                callbackAccept: function (popup) {
                    let ids = [];
                    Object.values(view.planningEmployeeThresholdMap).forEach(item => {
                        if (item.typeId == view.mainType.id) {
                            ids.push(item.id);
                        }
                    })
                    if (ids.length > 0) {
                        view.deleteMultipleEmployeeThreshold(ids);
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.couldNotDeleteData'));
                    }
                    popup.hidden = true;
                }, callbackCancel: function (popup) {
                    popup.loading = false;
                    popup.hidden = true;
                }
            });
        },
        deleteMultipleEmployeeThreshold: function (ids) {
            let view = this;
            let url = '/api/sec/planningemployeethreshold/any/delete';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                ids: ids,
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.meo.dataDeleted'));
                view.refresh(true);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.deleteDataError'));
                console.log(error)
            })

        },
        openCSVImportPopup() {
            let view = this;

            let dataEntries = [
                { label: this.$t('global.ui.csvFile'), accept: ".csv", key: 'file', hidden: false, type: 'file', value: null },
            ];

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (importf) {
                        if (importf.file.length > 0) {
                            view.parseCSVImport(importf.file[0])
                                .then(result => {
                                    view.openCSVImportConfirmAlert(result.data, result.missingSpots, result.noMatch);
                                }).catch(error => {
                                console.log(error);
                                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.importDataError'));
                            })

                        } else {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.main.noImportFileSelected'));
                        }
                    },
                },
                header: this.$t('indicator.meo.importData') + ': ' + this.mainType.name,
                remainAfterSelect: false,
                expanded: true,
                centered: true
            });
        },
        openCSVImportConfirmAlert(data, missingSpots, noMatch) {
            let view = this;
            let description = this.$t('indicator.meo.importDataQuery');
            if (missingSpots.length > 0) {
                description += this.$t('indicator.meo.importSpotMissing')
                description += "<div style='margin-left: 20px;'><ul>"
                missingSpots.forEach(name => {
                    description += "<li>" + name + "</li>";
                })
                description += "</ul></div>";
            }
            if (noMatch.length > 0) {
                description += this.$t('indicator.meo.importUnknownColumn')
                description += "<div style='margin-left: 20px;'><ul>"
                for (let i = 0; i < Math.min(5, noMatch.length); i++) {
                    description += "<li>" + noMatch[i] + "</li>";
                }

                description += "</ul></div>";
            }
            view.$helpers.OpenAlert({
                header: this.$t('indicator.meo.confirmImport'),
                description: description,
                callbackAccept: function (popup) {
                    if (data.length > 0) {
                        view.createMultiplePlanningEmployeeThreshold(data);
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.couldNotImportData'));
                    }
                    popup.hidden = true;
                }, callbackCancel: function (popup) {
                    popup.loading = false;
                    popup.hidden = true;
                }
            });
        },
        parseCSVImport(file) {
            let view = this;
            let spotNameMap = {};
            Object.values(this.spotMap).forEach(spot => {
                spotNameMap[spot.name.toLowerCase()] = { id: spot.id, imported: false, name: spot.name };
            });
            let noMatch = [];
            return new Promise((resolve, reject) => {
                Papa.parse(file,
                    {
                        header: true,
                        skipEmptyLines: true,
                        transformHeader: (header) => {
                            let headerOriginal = header;
                            if (header) {
                                header = header.trim().toLowerCase();
                            }
                            if (spotNameMap[header] != null) {
                                spotNameMap[header].imported = true;
                                return spotNameMap[header].id;
                            }
                            if (header == "wert" || header == 'umsatz' || header == "grenze") {
                                return "amount";
                            } else {
                                noMatch.push(headerOriginal);
                                return "no_matching_field";
                                //return header;
                            }

                        },
                        complete: (result, file) => {
                            let missingSpots = Object.values(spotNameMap).filter(i => !i.imported).map(i => i.name);

                            let data = view.transformImportData(result.data);
                            let resultObject = {
                                missingSpots: missingSpots,
                                data: data,
                                noMatch: noMatch
                            }
                            resolve(resultObject);
                        },
                        error: (error, file) => {
                            reject(error);

                        }
                    })
            })

        },
        transformImportData(data) {
            let result = [];
            data.forEach(entry => {
                Object.values(this.spotMap).forEach(spot => {

                    if (entry[spot.id] && parseInt(entry[spot.id]) >= 0 && entry.amount != null) {
                        result.push({
                            typeId: this.mainType.id,
                            threshold: parseFloat(entry.amount.replace(",", ".")),
                            spotId: spot.id,
                            employeeCount: parseInt(entry[spot.id])
                        });
                    }
                })
            })
            return result;
        },
        exportCSV() {
            let date = this.$helpers.getMomentTZ();
            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [ this.$t('workBalance.extraPay.value') ];
            let spots = Object.values(this.spotMap).sort((a, b) => a.name < b.name);
            console.log(spots)
            spots.forEach(spot => {
                headers.push(spot.name);
            })

            let filename = 'MEO_' + this.storeSettings.name + '_' + date.format("DD_MM_YYYY_HH_mm") + '.csv';

            csv += headers.join(";");
            csv += "\n";
            Object.entries(this.thresholdSpotEmployeeMap).forEach(a => {
                let key = a[0];
                let item = a[1];
                let cur = [ key ];
                spots.forEach(spot => {
                    if (item[spot.id]) {
                        cur.push(item[spot.id])
                    } else {
                        cur.push('');
                    }
                })
                csv += cur.join(";");
                csv += "\n";
            })

            let encodedUri = encodeURI(csvPre) + "\uFEFF" + encodeURIComponent(csv);

            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
    font-family: DistrictPro;
}

p {
    font-family: DistrictPro;
}

.vlh-lane {
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    min-height: 250px;
}

.vlh-lane-section {
    display: flex;
    padding-right: 24px;
    flex: 1;
    border-bottom: solid 2px var(--contrast-2);
    /* gap: 10px; */
    height: 100%;
}

.vlh-section-label {
    writing-mode: vertical-rl;
    transform: rotate(-180deg);
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: white;
    padding: 15px 10px 0 10px;
}

.vlh-light-btn {
    border: 0;
    color: white;
    cursor: pointer;
    float: right;
    padding: 0 2px 15px 2px;
}

.vlh-light-btn:hover {
    background-color: white;
    color: black;
}

.vlh-light-gray {
    background: var(--contrast-0);
}

.tablecontainer {
    padding-left: 30px;
    padding-right: 30px;
}

.has-header > .has-header > .scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    top: var(--header-height);
}

.header.top {
    margin: 10px 0;
}

.data-table {
    top: 10px;
    position: relative;
}

.header.date {
    display: inline-flex;
    justify-items: center;
    align-items: center;
    position: absolute;
    left: 20px;
}

.header.date .label {
    color: var(--contrast-4);
    font-family: DistrictProLight;
    font-weight: 200;
    margin-top: -3px;
}

.header.date .label.bold {
    font-family: DistrictProBold;
    font-weight: 800;
    margin-right: 5px;
    margin-top: -3px;
}

.header.date .fa-calendar {
    margin: 0 10px;
    font-size: 20px;
    margin-top: -3px;
}

.header.date .fa-angle-left {
    margin: 0 10px;
    font-size: 25px;
    color: var(--contrast-4);
}

.indicator-view {
    padding: 30px;
    padding-bottom: 50px;
}
</style>
